import { combineEpics, ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, filter, map, mergeMap, takeUntil } from 'rxjs/operators'

import { MAP_INCIDENT_TYPE_TO_URL_PREFIX } from '../constants'
import { COMMENT_AND_TAGS_UPDATE_ASYNC } from '../ReportCommunicationModal/constants'

import { editTagsError, editTagsSuccess, fetchTagsError, fetchTagsSuccess } from './actions'
import { EDIT_TAGS_REQUEST_ASYNC, TAGS_REQUEST_ASYNC } from './constants'

const FETCH_TAGS_TRIGGERS = [TAGS_REQUEST_ASYNC.INITIATE, COMMENT_AND_TAGS_UPDATE_ASYNC.SUCCESS]

const fetchTagsEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(...FETCH_TAGS_TRIGGERS),
    mergeMap((action) => {
      const { reportId, reportType, reportState } = action.payload
      return api.resolutionCenter
        .fetchTags(reportId, reportState, MAP_INCIDENT_TYPE_TO_URL_PREFIX[reportType])
        .pipe(
          map((response) => fetchTagsSuccess(response, reportId, reportType)),
          catchError((error) =>
            of(epicsErrorHandler((e) => fetchTagsError(e, reportId, reportType), error))
          ),
          // A newer fetch for the same report supersedes this one, so a stale response
          // (e.g. for the previous reportState) can't overwrite fresher tags.
          takeUntil(
            action$.pipe(
              ofType(...FETCH_TAGS_TRIGGERS),
              filter(
                ({ payload }) => payload.reportId === reportId && payload.reportType === reportType
              )
            )
          )
        )
    })
  )

const editTagsEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(EDIT_TAGS_REQUEST_ASYNC.INITIATE),
    mergeMap((action) => {
      const { reportId, reportType, type, tagsArr } = action.payload
      return api.resolutionCenter
        .editTags(reportId, type, tagsArr, MAP_INCIDENT_TYPE_TO_URL_PREFIX[reportType])
        .pipe(
          map(() => editTagsSuccess(tagsArr, reportId, reportType)),
          catchError((error) =>
            of(epicsErrorHandler((e) => editTagsError(e, reportId, reportType), error))
          ),
          takeUntil(action$.pipe(ofType(EDIT_TAGS_REQUEST_ASYNC.CANCEL)))
        )
    })
  )

export default combineEpics(fetchTagsEpic, editTagsEpic)
